import Utils from "./Utils";

declare let L:any;

class MapHelper {
    private element         =   null;
    private mapElement      =   null;
    private center          =   [];

    private static mBoxKey  =   null;

    public constructor(el: Element|string, center: any = []) {
        if (MapHelper.mBoxKey === null) {
            const key = Utils.getMeta("mapbox_api");
            if (key) {
                MapHelper.mBoxKey = key;
            }
            else {
                MapHelper.mBoxKey = false;
            }
        }

        if (MapHelper.mBoxKey === false) {
            throw new Error("Mapbox api key not found, maps will not initialize");
        }

        this.element = (typeof el === "string" ? document.getElementById(el) : el);
        this.mapElement = L.map(el, {
            dragging: false,
            tap: false
        });
        this.mapElement.scrollWheelZoom.disable();
        L.tileLayer('https://api.tiles.mapbox.com/v4/{id}/{z}/{x}/{y}.png?access_token={accessToken}', {
            attribution: 'Map data &copy; <a href="https://www.openstreetmap.org/">OpenStreetMap</a> contributors, <a href="https://creativecommons.org/licenses/by-sa/2.0/">CC-BY-SA</a>, Imagery © <a href="https://www.mapbox.com/">Mapbox</a>',
            maxZoom: 15,
            id: 'mapbox.streets',
            accessToken: MapHelper.mBoxKey
        }).addTo(this.mapElement);

        if (Array.isArray(center) && center.length === 2)
            this.center = center;
    }

    public getMap(): any {
        return this.mapElement;
    }

    public refreshMap(): void {
        this.mapElement.invalidateSize();
        if (this.center.length)
            this.mapElement.setView(this.center);
    }

    public el(): Element {
        return this.element;
    }
}

export default MapHelper;